import useToast from '@hooks/ui/useToast';
import { useFlow } from '@router/stackflow';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

function useInquiryCommentForm(inquiryId: string) {
    const { t } = useTranslation('inquiry');
    const toast = useToast();
    const [content, setContent] = useState<string>('');
    const [fileUrls, setFileUrls] = useState<string[]>([]);
    const { push } = useFlow();
    const handleCreateComment = () => {
        if (content.length === 0) {
            toast.error(t('comment.contentRequired'));
            return;
        }
        push('InquiryCommentModal', { inquiryId, content, fileUrls });
    };
    return {
        content,
        setContent,
        fileUrls,
        setFileUrls,
        handleCreateComment,
    };
}

export default useInquiryCommentForm;
